import Modal from "./Modal";
import Button from "./Button";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
}

/** Une action qui détruit ou retire quelque chose s'affiche en rouge ; les autres (verrouiller, réintégrer...) en vert. */
const DESTRUCTIVE = /supprim|annul|retir|désactiv|effac|départ/i;

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirmer",
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  const destructive = DESTRUCTIVE.test(confirmLabel) || DESTRUCTIVE.test(title);
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      icon={destructive ? "ri-alert-line" : "ri-question-line"}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button
            variant={destructive ? "danger" : "primary"}
            icon={destructive ? "ri-delete-bin-6-line" : "ri-check-line"}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm text-foreground-700 leading-relaxed break-words">{message}</p>
    </Modal>
  );
}